import type { ShapeData } from '@/lib/shapes/types/shape-data'

export function shapeUpdateOperation(
  before: Partial<ShapeData>,
  after: Partial<ShapeData>
): 'move' | 'update' | 'rotate' {
  const touchesRotation = before.rotation !== undefined || after.rotation !== undefined
  const touchesPosition =
    before.x !== undefined ||
    after.x !== undefined ||
    before.y !== undefined ||
    after.y !== undefined
  const touchesSize =
    before.width !== undefined ||
    after.width !== undefined ||
    before.height !== undefined ||
    after.height !== undefined
  const touchesPath =
    before.path !== undefined ||
    after.path !== undefined ||
    before.pathCommands !== undefined ||
    after.pathCommands !== undefined

  if (touchesRotation && !touchesPosition && !touchesSize && !touchesPath) return 'rotate'
  if (touchesRotation || touchesSize || touchesPath) return 'update'
  if (touchesPosition) return 'move'
  return 'update'
}
